import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          "bienvenue": "👋 Welcome to tripkygo v3",
          "itineraires": "travels",
          "nbItineraires": "created since june 2020",
          "planificateur" : "Travel planning tool",
          "planificateur2" : "Planning tool",
          "planificateur3" : "Travel planning",
          "planificateur4" : "tool",
          "description" : "Plan your own vacations, road trips or world tours by creating your travel itinerary.",
          "description1" : "Totally free, tripkygo is the travel planning tool you need to organize your holidays, road-trips or world tours. It allows you to calculate your budget, generate a map and edit travel diaries.",
          "description2": "In addition to the itinerary creator, our site includes section ",
          "description3": ", ", 
          "description4": " and a ", 
          "description5" : "Completely free, tripkygo is the travel planner tool you need to organize your vacations, road trips, or round-the-world trips.",
          "description6" : "Create your itinerary day by day, view your map, calculate your budget, and edit a travel diary. And to go even faster, let yourself be guided by our AI ​​assistant: it helps you find ideas, structure your steps and create a route adapted to your desires.",
          "creerMonItineraire" : "Create my itinerary",
           "voirExemple" : "See example",
          "titre1": "Organize your trip",
          "titre2": "without spreadsheets and without stress",
          "ouPartir" : "Where to go?",
          "ouPartirEn" : "Where to go in",
          "guidesPays" : "Country guides",
          "outilReservation" : "Booking tool",
          "voyagesPublics" : "Public travels",
          "infoVoyagesPublics" : "Only itineraries declared public by their creators are visible. Some information may be hidden.",
          "chargementVoyagesPublics" : "Loading public trips in progress, please wait...",
          "chargementGuide" : "Loading guide in progress, please wait...",
          "chargementVoyage" : "Loading itinerary in progress, please wait...",
          "plusVoyagesPublics" : "See more",
          "plusAimes" : "Most liked ❤️",
          "triPubCroi" : "Publication date decreasing",
          "triPubDecroi" : "Publication date increasing",
          "triCreaCroi" : "Creation date decreasing",
          "triCreaDecroi" : "Creation date increasing",
          "triNbJCroi" : "Number of days decreasing",
          "triNbJDecroi" : "Number of days increasing",
          "triNbLCroi" : "Number of likes decreasing",
          "triNbLDecroi" : "Number of likes increasing",
          "tri" : "Sort",
          "utilisateur" : "Username",
          "pays" : "Country",
          "paysS" : "countries",
          "autrePays" : "Other country?",
          "ville" : "City",
          "voyageNomade" : "Nomadic travel",
          "voyageSedentaire" : "Sedentary travel",
         "assistantIA" : "✨ AI assistant",
         "assistantIA2" : "AI assistant",
           "aucunLieuRenseigne" : "No place specified",
          "ouAllezVous" : "Where are you going?",
          "debutFin" : "Start - End",
          "voyageur" : "Traveler",
          "voyageurMin" : "traveler",
          "ajouterVoyageurs" : "Add traveler(s)",
          "nbVoyageurs" : "Nb of traveler(s)",
          "nombreVoyageurs" : "Number of traveler(s)",
          "nombreVoyageur" : "Number of traveler",
          "creer" : "Create",
          "modifier" : "Modify",
          "jours" : "days",
          "jour" : "Day",
          "joursMajuscule" : "Days",
          "lieuxMajuscule" : "Places",
          "jourMin" : "day",
          "cree" : "Created",
          "par" : "by",
          "le" : "on",
          "a" : "at",
          "mesVoyages": "My travels",
          "mesDemandes": "Pending queries",
          "voyagesPartages": "Shared travels",
          "statistiques": "Statistics",
          "aide" : "Help",
          "guides" : "Guides",
          "contact" : "Contact",
          "creerVoyage" : "Create travel",
          "destinationsPopulaires" : "Popular destinations",
          "reserverTransport" : "Book transport",
          "reserverAvion" : "Book flight",
          "reserverHebergement" : "Book accomodation",
          "reserverActivite" : "Book activity",
          "reserverAssurance" : "Buy an insurance",
          "louerVoiture" : "Rent a car",
          "aPropos" : "About us",
          "newsletter" : "Newsletter",
          "mentionsLegales" : "Legal notice",
          "creerItineraire" : "Create itinerary",
          "detailVoyage" : "Travel details",
          "monnaie" : "Currency",
          "enregistrement" : "Saving in progress, please wait...",
          "saisirPays" : "Enter country",
          "saisirVille" : "Enter city",
          "quandPartezVous" : "When are you traveling?",
          "aucune" : "none",
          "ajoutezDates" : "Add dates",
          "effacerTout" : "Clear all",
          "aucunResultat" : "No result",
          "resultat" : "Result",
          "hebergement" : "Accomodation",
          "vol" : "Flight",
          "transport" : "Train/bus",
          "activite" : "Activity",
          "assurance" : "Insurance",
          "voiture" : "Car",
          "monCompte" : "My account",
          "compte" : "Account",
          "compteMin" : "account",
          "reservation" : "Book",
          "accueil" : "Home",
          "rechercheTripkygo" : "Find on tripkygo",
          "guidesVoyage" : "Travel guides",
          "infoDestinations" : "All informations about your destinations",
          "infoDestination" : "All informations about this destination",
          "chercherDestination" : "Search destination",
          "consulter" : "Consult",
          "quandPartir" : "When to travel",
          "nosIncontournables" : "Our essentials",
          "conseilsVoyage" : "Our travel tips based on weather conditions and your desires",
          "formalites" : "Formalities",
          "notreSelection" : "Our selection of places not to be missed during a trip",
          "languesOfficielles" : "Officiel language(s)",
          "drapeau" : "Flag",
          "capitale" : "Capital",
          "plage" : "Beach",
          "nonConseille" : "Not recommended",
          "conseille" : "Recommended",
          "pasRecommandation" : "No recommendation for this destination.",
          "trouverDestination" : "We are going to help you to find you next travel destination",
          "souhaitPartir" : "When do you want to travel?",
          "janvier" : "January",
          "fevrier" : "February",
          "mars" : "March",
          "avril" : "April",
          "mai" : "May",
          "juin" : "June",
          "juillet" : "July",
          "aout" : "August",
          "septembre" : "September",
          "octobre" : "October",
          "novembre" : "November",
          "decembre" : "December",
          "en" : "in",
          "selectionOuPartir" : "Here is our selection to travel in",
          "enFonction" : "depending on the weather conditions and your desires",
          "introContact" : "A question, a suggestion, a bug report or something else? Contact us:",
          "nom" : "Name",
          "prenom" : "First name",
          "presentation" : "Presentation",
          "sujet" : "Subject",
          "envoyer" : "Send",
          "envoyerDemande" : "Send request",
          "_en" : "_en",
          "En" : "En",
          "nouveauVoyage" : "New travel",
          "aucunVoyageCree" : "None travel created",
          "aucunVoyagePartage" : "None travel shared",
          "voyagesCrees": "Created travels",
          "titreVoyagesPartages" : "Consultation trips by sharing",
          "general" : "General",
          "paysVisites" : "Visited countries",
          "paysVisiteMin" : "visited country",
          "depenses" : "Expenses",
          "deplacements" : "Traveling",
          "chargementStatistiques" : "Statistics calculation in progress, please wait...",
          "aucuneDepense" : "No expense",
          "aucunDeplacement" : "No traveling",
          "jaimeRecu" : "received like",
          "etape" : "stage",
          "voyage" : "travel",
          "depensesMin" : "spent",
          "parcourus" : "traveled",
          "dont" : "of which:",
          "repartition" : "Distribution",
          "avion" : "Plane",
          "bateau" : "Ship",
          "aPied" : "Walking",
          "velo" : "Bicycle",
          "nonRenseigne" : "Not specified",
          "jourPersonne" : "/day/person",
          "connexion" : "Log in",
          "deconnexion" : "Log out",
          "inscrire" : "Sign up",
          "ou" : "OR",
          "adresseEmail" : "Email address",
          "motDePasse" : "Password",
          "motDePasseOublie" : "Forgotten password?",
          "seConnecter" : "Log in",
          "creerCompte" : "Sign up",
          "pasInscrit" : "Not yet registered?",
          "reinitMdp" : "Password reset",
          "saisirEmail" : "Enter your email address",
          "inscription" : "Sign up",
          "resaisirEmail" : "Re-enter your email address",
          "dejaInscrit" : "Already registered?",
          "nouveauMdp" : "New password",
          "ancienMdp" : "Old password",
          "resaisirNouveauMdp" : "Re-enter your new password",
          "enregistrer" : "Save",
          "profil" : "Profile",
          "changerImage" : "Change picture",
          "voirProfil" : "See public profile",
          "accepteNewsletter" : "I agree to receive the newsletter",
          "nomUtilisateur" : "Username",
          "champsFacultatifs" : "Optional fields",
          "usernameInvalide" : "The username is invalid. It must be between 5 and 20 characters starting with a letter. Only letters, numbers, periods, hyphens and underscores are accepted!",
          "usernameDejaPris" : "This username is already taken, please choose another one!",
          "messageEmailInvalide1" : " Email used to create your ",
          "messageEmailInvalide2" : " is wrong, please ",
          "messageEmailInvalide3" : "contact us",
          "messageEmailInvalide4" : " to change it!",
          "nonVisible" : "(not visible on your public profile)",
          "infoPresentation" : "Introduce yourself to other users: your favorite destinations, your desires, your passions,...",
          "sitePersonnel" : "Personal website",
          "compteCreeLe" : "Account created on ",
          "gestionCompte" : "Account management",
          "confidentialite" : "Confidentiality",
          "confidentialiteVoyagesPublics": "Public travel confidentiality",
          "infoConfidentialiteVoyagesPublics": "Everyone has access to consult the trips that you decide to make public. Saved reservation confirmations and baggage checklists are never visible to visitors.",
          "info2ConfidentialiteVoyagesPublics": "You can decide whether or not to display the following information:",
          "affichageHebergements": "Display the name of the accommodations",
          "affichagePrix": "Display prices",
          "affichageBudget": "Display the budget and related costs",
          "affichagePhotos": "Display photos of the steps",
          "affichageDates": "Display dates for upcoming trips (end date not expired)",
          "affichageLiens": "Show links",
          "oui" : "Yes",
          "non" : "No",
          "changementMdp" : "Password change",
          "majMdp" : "Save password",
          "veuillezRemplirChamps" : "Please complete all fields.",
          "formatMdp": "The new password must contain at least one number, one lowercase letter, one uppercase letter and be at least 8 characters long.",
          "nouveauxMdpDifferents" : "The new passwords do not match.",
          "mdpDifferentAncien" : "The new password must be different from the old one.",
          "ancienMdpIncorrect" : "Wrong old password",
          "messageInscriptionGoogle" : "(Enter x if you signed up with Google)",
          "supprimerCompte" : "Delete my account",
          "suppressionEnCours" : "Deleting in progress...",
          "avertissementSuppression" : "By clicking the button, you will permanently delete your account and all the trips you have created!",
          "aPropos1" : "I am an IT developer living in Paris since 2005 and my greatest passion is travel!",
          "aPropos2" : "As a couple, we have visited more than 30 countries on 5 continents, you can find some of my travel diaries on my",
          "aPropos3" : "The idea of ​​a travel planning toolhad been bouncing around in my head for several months, tired of using impractical spreadsheets to organize our trips and not convinced by existing planners (too complicated, too long to fill out, not visual enough, etc...).",
          "aPropos4" : "It was thanks to the confinement of March 2020 that I was able to make this project a reality by developing this website during our long weekends and evenings in confinement. I wanted this planner to be as quick and visual as possible, allowing me to scan through the days in the blink of an eye.",
          "aPropos5" : "I constantly evolve the site based on the needs reported by users.",
          "aPropos6" : "In June 2024, for tripkygo's 4th anniversary, I launched this new, more modern, faster and more aesthetic site! Don't hesitate to send me your comments or ideas to improve the site.",
          "aPropos7" : "Good visit !",
          "inscriptionNewsletter" : "Subscribe to our newsletter",
          "infoNewsletter" : "to be informed of all the news on our site",
          "votre" : "Your",
          "sesVoyagesPublics" : "His/her public travels",
          "totalLikes" : "Number of likes on publics travels",
          "infosMasquees" : "Some information may be hidden.",
          "aucunVoyagePublic" : "None public travel.",
          "inscritEn" : "Registered on",
          "itinerairesPublics" : "Public itineraries",
          "reserverHotels" : "Book hotels, apartments,... with",
          "reserverTransports" : "Book your train or bus with",
          "reserverAvions" : "Book your flight with",
          "louerVoitureAvec" : "Rent a car with",
          "cliquerActivite" : "Click on activity to see other destinations on",
          "souscrireAssurance" : "Buy a travel insurance with",
          "infoGetYourGuide" : "By using this tool and booking with our partner GetYourGuide, tripkygo will earn a commission without changing the price you pay. We hope this will keep our site 100% free!",
          "infoBooking" : "By using this tool and booking with our partner Booking, tripkygo will earn a commission without changing the price you pay. We hope this will keep our site 100% free!",
          "infoKiwi" : "By using this tool and booking with our partner Kiwi, tripkygo will earn a commission without changing the price you pay. We hope this will keep our site 100% free!",
          "infoDiscoverCars" : "By using this tool and booking with our partner DiscoverCars, tripkygo will earn a commission without changing the price you pay. We hope this will keep our site 100% free!",
          "infoHeymondo" : "By using this tool and booking with our partner Heymondo, tripkygo will earn a commission and you will benefit from a 5% discount. We hope this will keep our site 100% free!",
          "titreItineraire" : "Travel title",
          "destinationEnregistree" : "Saved destination",
          "destinationsEnregistrees" : "Saved destinations",
          "resume" : "Summary",
          "carte" : "Map",
          "modeModif" : "Modification mode",
          "modeConsult" : "Consultation mode",
          "outils" : "Tools",
          "prive" : "Private",
          "lieu" : "Place",
          "repas" : "Meal",
          "trajet" : "Journey",
          "trajetPreRempli" : "Pre-filled Journey",
          "nuit" : "Night",
          "nuitMinuscule" : "night",
          "location" : "Rental",
          "masquees" : "hidden",
          "informationCookies1": "To display the reservation tool, you must accept 'Marketing' type cookies (",
          "informationCookies2": "see explanation",
          "informationCookies3": "To authorize 'Marketing' type cookies on the tripkygo site",
          "informationCookies4": ", please:",
          "informationCookies5": "1) click on the icon",
          "informationCookies6": "at the bottom right of your screen",
          "informationCookies7": "2) accept 'Marketing' type cookies",
          "informationCookies8": "3) click on 'Save' at the bottom of the window",
          "informationCookies9": "4) refresh the page",
          "informationCookies10": "Search tools will now be visible!",
          "informationCookies11": "By using these search tools, you will help keep our site 100% free!",
          "partage" : "Sharing",
          "copierLien" : "Copy link",
          "partagerFacebook" : "Share on Facebook",
          "partagerX" : "Share on X (Twitter)",
          "partagerProfil" : "Share profile",
          "envoyerParMail" : "Send by email",
          "envoyerParSms" : "Senb by sms",
          "envoyerParWhatsApp" : "Send by WhatsApp",
          "integrerBlog" : "Integrate on a site/blog",
          "itineraireVoyage" : "Travel itinerary",
          "messageRs" : "My travel itinerary crerated on @tripkygo_en",
          "messageRs2": "My travel itinerary may interest you",
          "lienCopie" : "Link copied",
          "enregistrementMaj" : "Saving",
          "creation" : "Creation",
          "enCours" : "in progress, please wait...",
          "aeroportGareVille"  : "Airport, station, city...",
          "compagnie"  : "Company",
          "refNumVol"  : "Ref, flight num,...",
          "debut" : "Start",
          "fin" : "End",
          "prix" : "Price",
          "paye?" : "Paid?",
          "paye" : "Paid",
          "nomVilleLieu"  : "Name of the city or the place",
          "activitesVisites" : "Activities, visits,...",
          "nomRestaurantLieu"  : "Name of the restaurant or the place",
          "descriptionRepas"  : "Description,...",
          "nomHebergement"  : "Name of the accommodation",
          "nomVille"  : "Name of the city",
          "prixNuit" : "Price/night",
          "reference"  : "Reference,...",
          "agenceBoutique" : "Agency, shop,...",
          "surPlace": "On site",
          "prelevement": "Debit",
          "acompte": "Deposit",
          "priseEnCharge": "Pick-up",
          "restitution": "Drop-off",
          "locationPriseEnCharge" : "Rental - pick up",
          "locationRestitution" : "Rental - drop-off",
          "rattacherPEC": "Link pick-up",
          "cliquezCompleter" : "Click to add",
          "nuitsIncompletes" : "Incomplete night(s)",
          "nuitTransport" : "Night in transport",
          "lieuxVisites" : "Visited places",
          "dateDebut" : "Start date:",
          "nombreNuits" : "Number of nights:",
          "villeSejourner" : "City where you will stay",
          "villeNonRenseignee" : "City ​​not specified",
          "paysNonRenseigneCliquez": "Country not specified. Click on the city and select it from the choices offered for automatic selection of the country or select the country below.",
          "paysNonRenseigne" : "Country not specified",
          "situationApresEnregistrement" : "Situation after saving:",
          "du" : "from",
          "au" : "to",
          "liberee" : "free",
          "questionAjout" : "What do you want to add?",
          "questionAjoutCoCreateur" : "Who would you like to add as a co-creator?",
          "cliquezPourEchanger" : "Click to exchange content with the next day",
          "coordonneesGPSAbsentes" : "Missing GPS coordinates",
          "coordinateRetentionTitle" : "Location not identified",
          "coordinateRetentionMessage" : "You changed {{field}} without selecting an item from the suggestions. The new location could not be identified.\n\nWould you like to keep the GPS coordinates previously saved for this item?",
          "coordinateRetentionClear" : "Clear",
          "coordinateRetentionKeep" : "Keep",
          "coordinateFieldPlace" : "the place name",
          "coordinateFieldCity" : "the city name",
          "coordinateFieldAccommodation" : "the accommodation name",
          "coordinateFieldDeparture" : "the departure place",
          "coordinateFieldArrival" : "the arrival place",
          "cliquezCarte" : "Click to see on map",
          "cliquezPlacement" : "Click to place on map",
          "recherche" : "Search",
          "blocNotes" : "Notepad",
          "confirmation" : "Confirmation",
          "coordonnees" : "Coordinates",
          "lien" : "Link",
          "suppression" : "Delete",
          "pointsInteret" : "Points of interest",
          "itineraire" : "Itinerary",
          "informations" : "Informations",
          "copie" : "Copy",
          "afficherStatistiques" : "Show statistics",
          "convertisseurMonnaies" : "Currencies convertor",
          "exporterItineraire" : "Export itinerary",
          "importerItineraire" : "Import itinerary",
          "editerPDF" : "Edit PDF",
          "integrerItineraire" : "Integrate itinerary on a blog/site",
          "faireMaValise" : "Make my suitcase",
          "partagerItineraire" : "Share itinerary",
          "chargementDiagramme" : "Diagram loading...",
          "repartitionBudget" : "Budget distribution",
          "activites" : "Activities",
          "hebergements" : "Accomodations",
          "autresFrais" : "Other costs",
          "frais" : "Costs",
          "fraisPersonnalises" : "Custom costs",
          "informationsFrais" : "Costs informations",
          "ajoutezInformations" : "Add information",
          "nouveauTypeFrais" : "New expense type...",
          "visas" : "Visa(s)",
          "vaccins" : "Vaccine(s)",
          "carburant" : "Fuel",
          "nourriture" : "Food",
          "vehicule" : "Véhicle",
          "autres" : "Others",
          "materiel" : "Material",
          "resteAPayer" : "Remains to pay",
          "dejaPaye" : "Already paid",
          "totalPour" : "Total for",
          "parPersonne" : "per person",
          "kmParcourus": "km traveled",
          "exportezItineraire" : "Export your itinerary to view it on other sites/applications (Google Maps, Maps.Me, OpenStreetMap,...).",
          "elementsExporter" : "Items to export",
          "tousExporter" : "All (places, meals, journeys, rentings and nights)",
          "seulementExporter" :"Only places and meals",
          "exporter" : "Export",
          "importezItineraire" : "Import map data in KML/KMZ format (Google Maps, Maps.Me, OpenStreetMap,...)",
          "kmlKmzAcceptes" : ".kml and kmz accepted",
          "lieuxImportes": "Imported places:",
          "selectionnezJour" : "Select a day",
          "selectionnezPositionnement" : "Select a positionning",
          "lieuAjoute" : "Day added",
          "integrationItineraire" : "Integration of the itinerary on your site/blog",
          "quelleVue" : "Which view do you want to display by default?",
          "previsualisezItineraire" : "Preview the integrated itinerary",
          "codeAUtiliser" : "Code to use:",
          "pourAjuster" : "To adjust the height of the window, read",
          "commentIntegrer" : "How to integrate a tripkygo itinerary on a site/blog?",
          "notificationEmail" : "Email notification 48h before departure?",
          "objet" : "Object",
          "ajouter" : "Add",
          "ajoutEnCours": "Adding in progress, please wait...",
          "echangeEnCours" : "Exchange in progress, please wait...",
          "copieEnCours" : "Copy in progress, please wait...",
          "gestionCoCreateurs" : "Co-creator management",
          "coCreateurs" : "Co-creator :",
          "envoiDemandeCoCreateurs" : "Sending request, please wait...",

          "alertPaysSaisi" : "You have already entered this country, please enter the next country or move on to entering the other criteria!",
          "alertDestination" : "You must select a destination!",
          "alertIADestinationInvalide" : "The AI ​​did not generate the trip correctly. Please clearly specify the destination to the AI ​​assistant.",
          "alertDateDeb" :"You must select a trip start date!",
          "alertDateFin" :"You must select a trip end date!",
          "alertNbVoyageurs" :"You must add at least 1 traveler!",
          "alertNbJoursMax" :"Your trip must not exceed 365 days! Please create multiple trips.",
          "alertNbJoursMin" :"Your trip must last at least two days.",
          "alertCopie" : "You must be logged in to copy a travel. \nDon't have an account? Subscribe, it's free !",
          "alertPartage" : "You must be logged in to share a travel. \nDon't have an account? Subscribe, it's free !",
          "alertCreateurs" : "You must be logged in to modify travel's creators. \nDon't have an account? Subscribe, it's free !",
          "alertMajConnecte" : "Error during update, you are no longer connected.",
          "alertSaisieRapide" : "Too fast...",
          "alertNom" : "You must enter a name!",
          "alertEmail" : "You must enter a valid email adress!",
          "alertSujet" : "You must enter a subject!",
          "alertMessage" : "You must enter a message of at least 30 characters!",
          "alertRecaptcha" : 'Please check the "I am not a robot" box.',
          "alertTechnique" : "Technical error!",
          "alertVerifReinit" : "Error while verifying reinit.",
          "alertMailIncorrect" : "Incorrect email address or reinit code",
          "alertDelaiReinit" : 'Reinit delay expired, please start the procedure again by clicking on "Forgotten password".',
          "alertEnvoiMail" : "Error during message sending",
          "alertPasCompte" : "No account for this email address!",
          "alertMailRecup" : "If an account exists for this email address, a password recovery email has been sent.",
          "alertMailRecupSuite" : "\nYou have 1 hour to complete the reset procedure otherwise you will have to start again.\nIf you can't find it, remember to check your spam folder or contact us!",
          "alertMailRecupFin" : "\nYou have 1 hour to carry out the reset procedure otherwise you will have to start again.\nIf you can't find it, remember to check your spam folder!\n\nIf your email is with orange.fr and you do not receive the email, please contact us because their server blocks our automatic email sending.",
          "alertMdpInvalide" : "Invalid password!\nPlease enter more than 5 characters with at least one number, one lowercase letter and one uppercase.",
          "alertMdpDifferents" : "Passwords entered are different!",
          "alertInscriptionImpossible" : "Registration impossible, there already exists an account for this email address!", 
          "alertDoubleMdp" : "You must complete both password fields!",
          "alertMdpModifie" : "Password changed!\nYou can now log in with your new password.",
          "alertErreurReinit" : "Error while resetting the password.",
          "alertUsernameInvalide" : "This username is invalid. It must be between 5 and 20 characters starting with a letter. Only letters, numbers, periods, hyphens and underscores are accepted!",
          "alertChampSiteInvalide": "The site is invalid. There cannot be a space in the URL address of a website.",
          "alertChampRSInvalide": "The username of a social network must therefore contain neither @ nor spaces.",
          "alertRecupProfil" : "Error while retrieving the profile",
          "alertEnregProfil" : "Error saving the profile, you are no longer connected.",
          "alertEnregPhoto" : "Error saving the picture, you are no longer connected.",
          "alertFormatFichier" : "Please select a JPEG, JPG, PNG, wEBP, HEIC or HEIF file.",
          "alertTailleFichier" : "The file size must not exceed 12 MB.",
          "alertEnregMdp" : "Error saving the new password, you are no longer connected.",
          "alertErreurSuppCompte" : "Error while deleting account",
          "alertPlusConnecte" : ", you are no longer connected.",
          "alertErreurNewsletter" : "Error during newsletter subscribing",
          "alertNewsletterOK" : "Subscription OK !",
          "emailVerificationTitle": "Email verification",
          "emailVerificationSent": "A confirmation email has been sent to",
          "emailVerificationInstruction": "Open it and click the confirmation link to activate your account.",
          "emailConfirmationTitle": "Email confirmation",
          "emailConfirmationLoading": "Your email address is being confirmed. Please wait a few seconds...",
          "emailConfirmationSuccess": "Email address confirmed!",
          "emailAccountActivated": "Your tripkygo account is now active. You can now log in.",
          "emailInvalidLinkTitle": "Invalid link",
          "emailConfirmationImpossible": "Confirmation failed",
          "emailBackToLogin": "Back to login",
          "emailLinkIncomplete": "The confirmation link is incomplete.",
          "emailConfirmationFailed": "Your email address could not be confirmed.",
          "emailLinkInvalid": "This confirmation link is invalid or has already been used.",
          "emailConfirmationError": "An error occurred while confirming your email address.",
          "alertVoyagePublic" : "This itinerary is public, do you want to make it private?\n\nIt will no longer be visible on our homepage.",
          "alertVoyagePrive" : "This itinerary is in private mode, would you like to make it public?\n\nIt will be accessible to everyone from our home page, you can share it and even integrate it on your blog or site. Enter your Instagram account on your tripkygo profile and we will mention you in an Instagram story to present your itinerary.\n\nYou can hide certain information by adjusting the privacy settings for your public trips in your account.",
          "alertAccepterCoCreateur": "You are now co-creator of this itinerary. After refreshing the page, it will appear in the list of your trips.",
          "alertRefuserCoCreateur": "Do you confirm your refusal to become co-creator of the trip?",
          "alertSupprimerCoCreateur": "Do you confirm the revocation of co-creator rights to ",

          "confirmRepousser" : "Are you sure you want to postpone the start of your trip and bring forward the end date? You will lose the saved data for the deleted dates.",
          "confirmDecaler" : "You shift the dates of your trip by keeping the same number of days, so you will keep all previously recorded data that will be shifted.",
          "confirmDiminuer" : "Are you sure you want to reduce the duration of your trip? You will lose the data saved for the deleted days.",
          "confirmSuppressionCompte" : "Are you sure you want to permanently delete your account and your trips?",

          "lienPlanificateur" : "/en/travel-planning",
          "lienMesVoyages": "/en/my-travels",
          "lienVoyagesPartages": "/en/shared-travels",
          "lienStatistiques": "/en/my-statistics",
          "lienVoyageur": "/en/traveler",
          "lienAide" : "/en/help",
          "lienGuides" : "/en/country-guides",
          "lienGuide" : "/en/country-guide",
          "lienContact" : "/en/contact",
          "lienHome" : "/en",
          "lienAPropos" : "/en/about-us",
          "lienNewsletter" : "/en/about-us#newsletter",
          "lienMentionsLegales" : "/en/legal-notice",
          "lienVoyagesPublics" : "/en/travels/publics",
          "lienOuPartir" : "/en/where-to-go",
          "lienReservation" : "/en/book",
          "lienReservationTransport" : "/en/book-transport",
          "lienReservationAvion" : "/en/book-flight",
          "lienReservationHebergement" : "/en/book-accomodation",
          "lienReservationActivite" : "/en/book-activity",
          "lienReservationAssurance" : "/en/book-insurance",
          "lienLocationVoiture" : "/en/rent-car",
          "lienCompte": "/en/account",
          "et": "and",
          "blog": "Blog",
          "lienLogin": "/en/login",
          "lienSignUp": "/en/signup",
          "lienCompteConfidentialite": "/en/account-confidentiality",
          "lienGestionCompte": "/en/account-management",
          "lienCompteMdp" : "/en/account-password",
          "lienItineraireIntegre" : "/en/travel-itinerary-embed",
          "trouvezInspiration" : "Find inspiration",
          "decouvrezIncontournables" : "Discover the Must-Sees",
          "activitesTransportsHebergements" : "Activities, transports, accomodations,...",
          "trierVoyages" : "Sort trips",
          "filtrerPays" : "Filter by country",
          "filtrerUtilisateur" : "Filter by user",
          "filtreRecherche" : "Search for a trip, a country, a user, etc...",
          "reinitialiser" : "Reset",
          "aucunVoyageTrouve" : "No trips found matching these criteria",
          "essayerModifier" : "ry modifying your filters or resetting the search", 
          "veuillezPatienter" : "Please wait...",
          "envoyerIA" : "✨ Send to AI",
          "analyseDemande" : "✨ Analysis of your request...",
          "resultatApproche" :  "⏳ Result in approach...",
          "generationVoyage" : "🗺 Generating trip...",
          "informationsManquantes" : "✨ Missing informations...",
          "creerVoyageAssistant" : "Create your trip with our AI assistant",
          "aiTripBetaNotice": "The AI assistant is in beta: it can still make mistakes or suggest an itinerary that needs adjusting. You can ask it to revise the result before creating your trip.",
          "aiTripPreparing": "The assistant is preparing your custom trip.",
          "aiTripGenerated": "✨ Trip generated",
          "destination": "Destination",
          "destinations": "Destinations",
          "dates": "Dates",
          "decrivezVoyage" : "Simply describe your trip.",
          "exemple1" : "Exemples :",
          "exemple2" : "- 2 weeks in Japan starting April 24, 2028",
          "exemple3" : "- I want to go to South America from June 3 to July 3, 2027",
          "exemple4" : "- Find me a destination in Italy for a week near the sea in October 2026",
          "completezDemande" : "Complete or refine the result by sending more messages to the AI",
          "limiteIA1" : "⏳ You have reached the request limit for a non-logged-in user. Please log in to an account to continue.",
          "limiteIA2" : "⏳ You have reached the limit of 20 requests per hour. Please try again later.",
          "erreurSurvenue" : "An error has occured",
          "duree" : "Duration",
          "creerLeVoyage" : "Create trip",
          "effacerSuggestion" : "Delete suggestion",
          "suggestionItineraire" : "Itinerary suggestion",
          "mardi" : "Tuesday",
          "gareHakone" : "Hakone-Yumoto station",
          "gareKyoto" : "Kyoto station",
            "japon" : "Japan",
            "modalPlannerAI": {
  "title": "AI assistant",
  "subtitle": "I can complete, check, or improve your itinerary.",
  "concernedDay": "Concerned day",
  "allDays": "All days / no specific day",
  "quickActions": "Quick actions",
  "customRequest": "Custom request or question",
  "placeholder": "Example: add cultural activities in Kyoto without too much walking",
"placeholderAfterActivities": "Example: I want at least 3 activities per day",
"placeholderAfterTransports": "Example: I would prefer to travel between Medellín and Bogotá by plane",
"placeholderAfterNights": "Example: I want to spend more nights in Bangkok",
"placeholderAfterCheck": "Example: Can you suggest another improvement?",
"placeholderAfterQuestion": "Example: I would like to clarify my request...",
  "forgetConversation": "Forget conversation",
  "sendToAI": "Send to AI",
  "analysisInProgress": "Analysis in progress...",
  "assistantAnalyzing": "The assistant is analyzing your itinerary...",
  "assistantResponse": "Assistant response",
  "summary": "Summary",
  "warnings": "Points of attention",
  "suggestedActions": "Suggested actions",
  "informations": "Information",
  "remove": "Remove",
  "close": "Close",
  "applyProposal": "Apply proposal",
  "betaLabel": "Information about the beta version of the AI assistant",
  "betaNotice": "The AI assistant is in beta: it can still make mistakes or provide answers that need adjusting. You can ask it to revise the result before applying a proposal.",
  "processing": "Processing, please wait...",
  "processingShort": "Processing...",
  "applyError": "An error occurred while applying the proposal.",


  "chooseActionError": "Choose an action or write a request before sending it to the AI.",
  "loginRequired": "You must be logged in to an account to continue using the AI assistant.",
  "limitReached": "The AI request limit has been reached. Please try again later.",
  "incompleteRequest": "The request sent to the assistant is incomplete.",
  "assistantError": "Error while calling the AI assistant.",
  "assistantDefaultResponse": "The assistant replied.",

  "addActivities": "Add activities/visits",
  "fixTransports": "Add/fix transports",
  "rebalanceNights": "Rebalance nights",
  "checkItinerary": "Check consistency",
  "askQuestion": "Ask a question",

  "meal": "Meal",
  "place": "Place",
  "transport": "Transport",
  "transportToFix": "Transport to fix",
  "rebalance": "Rebalance",
  "suggestion": "Suggestion",
  "information": "Information",
  "proposal": "Proposal",

  "groupSinglePlaces": "You can ask the AI to group these items by city to create fewer \"Place\" items",
  "groupedDayInfo": "Activities grouped into a single \"Place\" item, but you can ask the AI to create one \"Place\" item per activity/visit",
  "transportMean": "Transport type:",
  "itineraryProposal": "Itinerary proposal",
  "nightsOnlyModified": "If you apply this change, only night elements will be modified.",
  "stage": "Step",
  "days": "Days",
  "to": "to",
  "night": "night",
  "nights": "nights",

  "plane": "Plane",
  "train": "Train/subway",
  "car": "Car",
  "bus": "Bus",
  "taxi": "Taxi",
  "ship": "Boat",
  "walking": "Walking",
  "bicycle": "Bicycle",
  "motorcycle": "Motorbike/Scooter"
},
"lieuxMinuscule": "places",
"groupe": "Group",
"legende": "Legend",
"masquerLegende": "Click to hide the legend",
"libelles": "Labels",
"mapPlacementAlert": "To add coordinates by right-clicking on the map, or by long-pressing on touch screens, please first select the place without GPS coordinates by clicking the pink icon next to its label.",
"calculItineraireEnCours": "Route calculation in progress, please wait...",
"photoBulk": {
  "addPhotos": "Add photos",
  "selectPhotos": "Add photos",
  "dropTitle": "Drag and drop your photos here",
  "dropNow": "Drop your photos here",
  "dropHint": "or select them from your device",
  "browse": "or click",
  "formats": "JPEG, PNG, WEBP, HEIC or HEIF · 12 MB maximum per photo",
  "title": "Associate photos with steps",
  "intro": "A stop can be associated with a photo only if it has a label.",
"introSuite": "We use the photo's date and GPS coordinates, when available, to suggest a stop. You can change or remove each association before saving.",
  "information": "Information",
"batchLimit": "Only the first {{count}} photos in this selection are displayed.",
  "invalidFormat": "Unsupported file format (JPEG, PNG, WEBP, HEIC or HEIF only).",
  "tooLarge": "This photo exceeds the 12 MB limit.",
  "readingMetadata": "Reading photo information...",
  "preparing": "Processing photos...",
  "preparingHint": "Creating previews, reading metadata and sorting photos.",
  "noDate": "Date unavailable",
  "noGps": "GPS unavailable",
  "association": "Associated stop",
  "notAssociated": "Do not save this photo",
  "replacesExisting": "will replace the current photo",
  "replaceWarning": "This stop already has a photo. It will be replaced after confirmation.",
  "remove": "Remove",
  "selectedCount": "{{count}} associated photo(s)",
  "progress": "Saving {{current}} of {{total}}...",
  "uploading": "Saving...",
  "validate": "Save associated photos",
  "uploadError": "An error occurred while saving the photos. Photos already processed may have been saved.",
  "loading": "Loading photos, please wait...",
  "noneInPlanner": "No photo has been added",
  "none": "No photos",
  "showAll": "Show all",
  "deleteConfirmation": "Permanently delete the photo associated with {{label}}?",
  "deleteError": "The photo could not be deleted. Please try again.",
    "annuler": "Cancel"
},
"planner": {
  "loading": "Loading...",
  "fileProcessing": "Processing file...",
  "betweenAdjacentItems": "Based on the previous and next items",
  "mapNeedsLocation": "To view the map, you must first add at least one geolocated place to the itinerary.",
  "mapNoLocation": "There are no geolocated places in the itinerary to display on the map.",
  "notesPlaceholder": "Write down your ideas or additional information for this stop...",
  "notesPrivacy": "Notes are visible only to the trip creator and when sharing a trip if the option has been selected.",
  "linkEdit": "Add/edit a link",
  "linkPlaceholder": "Enter the link",
  "status": "Status:",
  "reason": "Reason:",
  "publicLink": "Link shown to other users (public or shared trips):",
  "linkReview": "For public or shared trips, links are visible to other users only after validation by our team (within 48 hours).",
  "affiliateWarning": "Affiliate identifiers in links may be removed or replaced by our team during validation.",
  "linkPrivacy": "Show or hide links from your public trips in your account privacy settings.",
  "linkRejected": "link rejected",
  "linkApproved": "link approved",
  "linkModified": "link approved after modification by our team",
  "linkPending": "validation pending",
  "gpsEdit": "Add/edit GPS coordinates",
  "gpsMapHint": "Coordinates can also be added and edited directly from the map.",
  "bookingDocumentEdit": "Add/edit a booking confirmation",
  "bookingDocument": "Booking confirmation",
  "acceptedFiles": "JPEG, JPG, PNG, WEBP, HEIC and HEIF accepted, 12 MB maximum",
  "documentRetentionBefore": "Documents will be deleted",
  "documentRetentionDuration": "3 months",
  "documentRetentionAfter": "after the trip end date.",
  "documentRetentionAdvice": "To keep them, remember to generate a PDF version of the itinerary from My trips.",
  "pastTripDocument": "You cannot add a booking confirmation to a trip whose end date has passed.",
  "page": "Page",
  "of": "of",
  "shareTitle": "Individual sharing",
  "shareRecipient": "Who would you like to share your trip with?",
  "shareOptions": "Would you like to share the following information?",
  "budgetView": "Budget view",
  "confirmations": "Confirmations",
  "links": "Links",
  "share": "Share",
  "shareNotice": "The person you share your trip with will not be able to make any changes.",
  "sharePdfNotice": "They will be able to generate the roadmap as a PDF, but not the photo travel book.",
  "sharing": "Sharing in progress, please wait...",
  "pdfTitle": "PDF export",
  "pdfTypeQuestion": "What type of document would you like to create?",
  "roadmap": "Roadmap",
  "photoBook": "Travel book with photos",
  "includeQuestion": "Would you like to include the following information?",
  "gpsCoordinates": "GPS coordinates",
  "generate": "Generate",
  "pdfGenerating": "PDF generation in progress, please wait...",
  "coCreatorNotice": "Co-creators have access to all trip information. They can edit and share it, but cannot delete it or add other co-creators.",
  "readOnlyShareBefore": "To provide read-only access, use the",
  "readOnlyShareLink": "sharing feature",
  "totalNightsQuestion": "Enter the total number of nights you will spend at this accommodation:",
  "numberOfNights": "Number of nights",
  "copy": "Copy",
  "nearbyPoi": "Points of interest near this stop",
  "noNearbyPoi": "No nearby point of interest found",
  "providedBy": "Provided by",
  "addToActivities": "Add to this stop's activities",
  "createNewStop": "Create a new stop",
  "addedToActivities": "Added to this stop's activities!",
  "placeCreated": "Place created!",
  "coCreatorRequestBefore": "Do you accept",
  "coCreatorRequestAfter": "'s request to become a co-creator of trip no.",
  "newLabel": "NEW",
  "v3Announcement": "You can now add several photos at once and easily associate them with your trip stops. Go to the planner's Photos tab 📸",
  "surveyTitle": "YOUR OPIN MATTERS (only 2 questions):",
  "surveySubscription": "As part of tripkygo's development 🚀, would you be interested in a low-cost subscription to access premium features?",
  "examples": "Examples:",
  "premiumMobile": "access to a mobile app to view trips offline",
  "premiumPhotos": "add several photos per stop",
  "premiumGroupCosts": "group expense calculator to split costs between participants",
  "premiumCurrencies": "manage several currencies within the same trip",
  "premiumRoadRoute": "draw a road route on the map",
  "premiumBookLayout": "customize the travel book layout",
  "yes": "Yes 👍",
  "no": "No 👎",
  "surveyPrice": "What is the maximum monthly amount you would be willing to pay for this premium subscription?",
  "surveyPriceHint": "Higher subscription = more features",
  "perMonth": "/month",
  "moreThan": "more than",
  "sendAnswer": "Send my answer",
  "refuseError": "An error occurred while refusing the request.",
  "usernameRequiredToRefuse": "You must enter a username in My account before you can refuse to become a trip co-creator."
}
        }
      },
      fr: {
        translation: {
          "bienvenue": "👋 Bienvenue sur tripkygo v3",
           "itineraires": "itinéraires",
          "nbItineraires": "crées depuis juin 2020",
          "planificateur" : "Planificateur de voyages",
          "planificateur2" : "Planificateur",
          "planificateur3" : "Planificateur de",
          "planificateur4" : "voyages",
          "titre1" : "Organisez votre voyage",
          "titre2" : "sans tableur et sans stress",
          "description" : "Planifiez vous-mêmes vos vacances, road-trips ou tours du monde en créant votre itinéraire de voyage.",
          "description1" : "Totalement gratuit, tripkygo est le planificateur de voyage qu'il vous faut pour organiser vos vacances, road-trips ou tours du monde. Il permet notamment de calculer votre budget, de générer une carte et d'éditer des carnets de voyages.",
          "description2": "En plus de l'outil de création d'itinéraires, notre site comprend une section ", 
          "description3": ", des ", 
          "description4": " et un ", 
          "description5" : "Totalement gratuit, tripkygo est le planificateur de voyage qu'il vous faut pour organiser vos vacances, road-trips ou tours du monde.",
          "description6" : "Créez votre itinéraire jour par jour, visualisez votre carte, calculez votre budget et éditez un carnet de voyage. Et pour aller encore plus vite, laissez-vous guider par notre assistant IA : il vous aide à trouver des idées, structurer vos étapes et créer un itinéraire adapté à vos envies.",
          "creerMonItineraire" : "Créer mon itineraire",
          "voirExemple" : "Voir un exemple",
          "ouPartir" : "Où partir ?",
          "ouPartirEn" : "Où partir en",
          "guidesPays" : "Guides par pays",
          "outilReservation" : "Outil de réservation",
          "reservation" : "Réservation",
          "voyagesPublics" : "Voyages publics",
          "infosMasquees" : "Certaines informations peuvent être masquées.",
          "infoVoyagesPublics" : "Seuls les itinéraires déclarés publics par leur créateur sont visibles. Certaines informations peuvent être masquées.",
          "chargementVoyagesPublics" : "Chargement des voyages publics en cours, merci de patienter...",
          "chargementGuide" : "Chargement du guide en cours, veuillez patienter...",
          "chargementVoyage" : "Chargement du voyage en cours, merci de patienter...",
          "plusVoyagesPublics" : "Voir + voyages",
          "plusAimes" : "Les + aimés ❤️",
          "triPubCroi" : "Date de publication déroissante",
          "triPubDecroi" : "Date de publication croissante",
          "triCreaCroi" : "Date de création décroissante",
          "triCreaDecroi" : "Date de création croissante",
          "triNbJCroi" : "Nombre de jours décroissant",
          "triNbJDecroi" : "Nombre de jours croissant",
          "triNbLCroi" : "Nombre de likes décroissant",
          "triNbLDecroi" : "Nombre de likes croissant",
          "tri" : "Tri",
          "utilisateur" : "Utilisateur",
          "pays" : "Pays",
          "paysS" : "pays",
          "autrePays" : "Autre pays ?",
          "ville" : "Ville",
          "voyageNomade" : "Voyage nomade",
          "voyageSedentaire" : "Voyage sédentaire",
          "assistantIA" : "✨ Assistant IA",
          "assistantIA2" : "Assistant IA",
            "aucunLieuRenseigne" : "Aucun lieu renseigné",
          "ouAllezVous" : "Où allez-vous ?",
          "debutFin" : "Début - Fin",
          "voyageur" : "Voyageur",
          "voyageurMin" : "voyageur",
          "ajouterVoyageurs" : "Ajouter voyageur(s)",
          "nbVoyageurs" : "Nb de voyageur(s)",
          "nombreVoyageurs" : "Nombre de voyageur(s)",
          "nombreVoyageur" : "Nombre de voyageur",
          "creer" : "Créer",
          "modifier" : "Modifier",
          "jours" : "jours",
          "joursMajuscule" : "Jours",
          "lieuxMajuscule" : "Lieux",
          "jour" : "Jour",
          "jourMin" : "jour",
          "cree" : "Créé",
          "par" : "par",
          "le" : "le",
          "a" : "à",
          "mesVoyages": "Mes voyages",
          "mesDemandes": "Demandes en attente",
          "voyagesPartages": "Voyages partagés",
          "statistiques": "Statistiques",
          "aide" : "Aide",
          "guides" : "Guides",
          "blog" : "Blog",
          "contact" : "Contact",
          "creerVoyage" : "Créer un voyage",
          "destinationsPopulaires" : "Destinations populaires",
          "reserverTransport" : "Réserver un transport",
          "reserverAvion" : "Réserver un vol",
          "reserverHebergement" : "Réserver un hôtel",
          "reserverActivite" : "Réserver une activité",
          "reserverAssurance" : "Souscrire une assurance",
          "louerVoiture" : "Louer une voiture",
          "aPropos" : "À propos",
          "newsletter" : "Newsletter",
          "mentionsLegales" : "Mentions légales",
          "creerItineraire" : "Créer un itinéraire",
          "detailVoyage" : "Détail du voyage",
          "monnaie" : "Monnaie",
          "enregistrement" : "Enregistrement en cours, veuillez patienter...",
          "saisirPays" : "Saisir un pays",
          "saisirVille" : "Saisir une ville",
          "quandPartezVous" : "Quand partez-vous ?",
          "aucune" : "Aucune",
          "ajoutezDates" : "Ajoutez dates",
          "effacerTout" : "Effacer tout",
          "aucunResultat" : "Aucun résultat",
          "resultat" : "Résultat",
          "hebergement" : "Hébergement",
          "vol" : "Vol",
          "transport" : "Train/bus",
          "activite" : "Activité",
          "assurance" : "Assurance",
          "voiture" : "Voiture",
          "monCompte" : "Mon compte",
          "compte" : "Compte",
          "compteMin" : "compte",
          "accueil" : "Accueil",
          "rechercheTripkygo" : "Chercher sur tripkygo",
          "guidesVoyage" : "Guides de voyage",
          "infoDestinations" : "Toutes les informations sur vos destinations",
          "infoDestination" : "Toutes les informations sur cette destination",
          "chercherDestination" : "Chercher une destination",
          "consulter" : "Consulter",
          "quandPartir" : "Quand partir",
          "nosIncontournables" : "Nos incontournables",
          "conseilsVoyage" : "Nos conseils de voyage en fonction des conditions climatiques et de vos envies",
          "formalites" : "Formalités",
          "notreSelection" : "Notre sélection de lieux à ne pas râter lors d'un voyage",
          "languesOfficielles" : "Langue(s) officielle(s)",
          "drapeau" : "Drapeau",
          "capitale" : "Capitale",
          "plage" : "Plage",
          "nonConseille" : "Non conseillé",
          "conseille" : "Conseillé",
          "pasRecommandation" : "Pas de recommandation pour cette destination.",
          "trouverDestination" : "Nous allons vous aider à trouver votre prochaine destination de voyage",
          "souhaitPartir" : "Quand souhaitez-vous partir ?",
          "janvier" : "Janvier",
          "fevrier" : "Février",
          "mars" : "Mars",
          "avril" : "Avril",
          "mai" : "Mai",
          "juin" : "Juin",
          "juillet" : "Juillet",
          "aout" : "Août",
          "septembre" : "Septembre",
          "octobre" : "Octobre",
          "novembre" : "Novembre",
          "decembre" : "Décembre",
          "en" : "en",
          "selectionOuPartir" : "Voici notre sélection pour partir en",
          "enFonction" : "en fonction des conditions météorologiques et de vos envies",
          "introContact" : "Une question, une suggestion, un signalement de bug ou autre ? Contactez-nous :",
          "nom" : "Nom",
          "prenom" : "Prénom",
          "presentation" : "Présentation",
          "sujet" : "Sujet",
          "envoyer" : "Envoyer",
          "envoyerDemande" : "Envoyer une demande",
          "_en" : "",
          "En" : "",
          "nouveauVoyage" : "Nouveau voyage",
          "aucunVoyageCree" : "Aucun voyage créé",
          "aucunVoyagePartage" : "Aucun voyage ne vous a été partagé",
          "voyagesCrees": "Voyages créés",
          "titreVoyagesPartages" : "Voyages en consultation suite à un partage",
          "general" : "Général",
          "paysVisites" : "Pays visités",
          "paysVisiteMin" : "pays visité",
          "depenses" : "Dépenses",
          "deplacements" : "Déplacements",
          "chargementStatistiques" : "Calcul  des statistiques en cours, veuillez patienter...",
          "aucuneDepense" : "Aucune dépense",
          "aucunDeplacement" : "Aucune déplacement",
          "jaimeRecu" : "j'aime reçu",
          "etape" : "étape",
          "voyage" : "voyage",
          "depensesMin" : "dépensés",
          "parcourus" : "parcourus",
          "dont" : "dont :",
          "repartition" : "Répartition",
          "avion" : "Avion",
          "bateau" : "Bateau",
          "aPied" : "A pied",
          "velo" : "Vélo",
          "nonRenseigne" : "Non renseigné",
          "jourPersonne" : "/jour/personne",
          "connexion" : "Connexion",
          "deconnexion" : "Déconnexion",
          "inscrire" : "S'inscrire",
          "ou" : "OU",
          "adresseEmail" : "Adresse email",
          "motDePasse" : "Mot de passe",
          "motDePasseOublie" : "Mot de passe oublié ?",
          "seConnecter" : "Se connecter",
          "creerCompte" : "Créer un compte",
          "pasInscrit" : "Pas encore inscrit ?",
          "reinitMdp" : "Réinitialisation de mot de passe",
          "saisirEmail" : "Saisir votre adresse email",
          "inscription" : "Inscription",
          "resaisirEmail" : "Resaisissez votre mot de passe",
          "dejaInscrit" : "Déjà inscrit ?",
          "nouveauMdp" : "Nouveau mot de passe",
          "ancienMdp" : "Ancien mot de passe",
          "resaisirNouveauMdp" : "Resaisissez votre nouveau mot de passe",
          "enregistrer" : "Enregistrer",
          "profil" : "Profil",
          "changerImage" : "Changer l'image",
          "voirProfil" : "Voir votre profil public",
          "accepteNewsletter" : "J'accepte de recevoir la newsletter",
          "nomUtilisateur" : "Nom d'utilisateur",
          "champsFacultatifs" : "Champs facultatifs",
          "usernameInvalide" : "Le nom d'utilisateur n'est pas valide. Il doit faire entre 5 et 20 caractères en commençant par une lettre. Seuls les lettres, chiffres, points, tirets et tirets bas sont acceptés !",
          "usernameDejaPris" : "Ce nom d'utilisateur est déjà pris, veuillez en choisir un autre !",
          "messageEmailInvalide1" : " L'email utilisé pour créer votre ",
          "messageEmailInvalide2" : " est erroné, veuillez ",
          "messageEmailInvalide3" : "nous contacter",
          "messageEmailInvalide4" : " pour le rectifier !",
          "nonVisible" : "(non visible sur votre profil public)",
          "infoPresentation" : "Présentez-vous aux autres utilisateurs : vos destinations préférées, vos envies, vos passions,...",
          "sitePersonnel" : "Site internet personnel",
          "compteCreeLe" : "Compte créé le ",
          "gestionCompte" : "Gestion compte",
          "confidentialite" : "Confidentialité",
          "confidentialiteVoyagesPublics" : "Confidentialité des voyages publics",
          "infoConfidentialiteVoyagesPublics" : "Tout le monde a accès en consultation aux voyages que vous décidez de rendre publics. Les confirmations de réservation enregistrées et les check-lists de bagage ne sont jamais visibles par les visiteurs.",
          "info2ConfidentialiteVoyagesPublics" : "Vous pouvez décider de l'affichage ou non des informations suivantes :",
          "affichageHebergements" : "Afficher le nom des hébergements",
          "affichagePrix" : "Afficher les prix",
          "affichageBudget" : "Afficher le budget et les frais annexes",
          "affichagePhotos" : "Afficher les photos des étapes",
          "affichageDates" : "Afficher les dates pour les voyages à venir (date de fin non échue)",
          "affichageLiens" : "Afficher les liens",
          "oui" : "Oui",
          "non" : "Non",
          "changementMdp" : "Changement de mot de passe",
          "majMdp" : "Mettre à jour le mot de passe",
          "veuillezRemplirChamps" : "Veuillez remplir tous les champs.",
          "formatMdp": "Le nouveau mot de passe doit contenir au moins un chiffre, une lettre minuscule, une lettre majuscule et être d'au moins 8 caractères.",
          "nouveauxMdpDifferents" : "Les nouveaux mots de passe ne correspondent pas.",
          "mdpDifferentAncien" : "Le nouveau mot de passe doit être différent de l'ancien.",
          "ancienMdpIncorrect" : "Ancien mot de passe incorrect",
          "messageInscriptionGoogle" : "(Saisissez x si vous vous êtes inscrit(e) avec Google)",
          "supprimerCompte" : "Supprimer mon compte",
          "suppressionEnCours" : "Suppression en cours...",
          "avertissementSuppression" : "En cliquant sur le bouton, vous supprimerez définitivement votre compte et tous les voyages que vous avez créés !",
          "aPropos1" : "Je suis un informaticien vivant à Paris depuis 2005 et ma plus grande passion est le voyage !",
          "aPropos2" : "En couple, nous avons visité plus de 30 pays sur 5 continents, vous pouvez retrouvez une partie de mes carnets de voyages sur mon ",
          "aPropos3" : "L'idée du planificateur de voyages me trottait dans la tête depuis plusieurs mois, lassé d'utiliser des tableurs peu pratiques pour organiser nos voyages et non convaincu par les planificateurs existants (trop compliqués, trop longs à remplir, pas assez visuels,...).",
          "aPropos4" : "C'est grâce au confinement de Mars 2020 que j'ai pu concrétiser ce projet en développant ce site internet durant nos longs week-end et soirées confinés. J'ai voulu ce planificateur le plus rapide et le plus visuel possible en permettant de balayer les journées en un clin d'oeil.",
          "aPropos5" : "Je fais évoluer le site constamment en fonction des besoins remontés par les utilisateurs.",
          "aPropos6" : "En Juin 2024, pour les 4 ans de tripkygo, j'ai lancé ce nouveau site plus moderne, plus rapide et plus esthétique ! N'hesitez pas à m'envoyer vos remarques ou idées pour améliorer le site.",
          "aPropos7" : "Bonne visite !",
          "inscriptionNewsletter": "Inscrivez-vous à notre newsletter",
          "infoNewsletter" : "pour être informé(e) de toutes les nouveautés de notre site",
          "votre" : "Votre",
          "sesVoyagesPublics" : "Ses voyages publics",
          "totalLikes" : "Total du nombre de likes sur ses voyages publics",
          "aucunVoyagePublic" : "Aucun voyage public.",
          "inscritEn" : "Inscrit(e) en",
          "itinerairesPublics" : "Itinéraires publics",
          "reserverHotels" : "Réservez vos hôtels, appartements,... avec",
          "reserverTransports" : "Réservez vos billets de train ou de bus avec",
          "reserverAvions" : "Réservez vos billets d'avion avec",
          "louerVoitureAvec" : "Louez un véhicule avec",
          "cliquerActivite" : "Cliquez sur une activité pour consulter d'autres destinations sur",
          "souscrireAssurance" : "Souscrivez à une assurance voyage avec",
          "infoGetYourGuide" : "En utilisant cet outil et en réservant chez notre partenaire GetYourGuide, tripkygo touchera une commission sans modifier le prix que vous paierez. Nous espérons que cela permettra de maintenir notre site 100% gratuit !",
          "infoBooking" : "En utilisant cet outil et en réservant chez notre partenaire Booking, tripkygo touchera une commission sans modifier le prix que vous paierez. Nous espérons que cela permettra de maintenir notre site 100% gratuit !",
          "infoKiwi" : "En utilisant cet outil et en réservant chez notre partenaire Kiwi, tripkygo touchera une commission sans modifier le prix que vous paierez. Nous espérons que cela permettra de maintenir notre site 100% gratuit !",
          "infoDiscoverCars" : "En utilisant cet outil et en réservant chez notre partenaire DiscoverCars, tripkygo touchera une commission sans modifier le prix que vous paierez. Nous espérons que cela permettra de maintenir notre site 100% gratuit !",
          "infoHeymondo" : "En utilisant cet outil et en réservant chez notre partenaire Heymondo, tripkygo touchera une commission et vous bénéficierez de 5% de réduction. Nous espérons que cela permettra de maintenir notre site 100% gratuit !",
          "titreItineraire" : "Titre de l'itinéraire",
          "destinationEnregistree" : "Destination enregistrée",
          "destinationsEnregistrees" : "Destinations enregistrées",
          "resume" : "Résumé",
          "carte" : "Carte",
          "modeModif" : "Mode modification",
          "modeConsult" : "Mode consultation",
          "outils" : "Outils",
          "prive" : "Privé",
          "lieu" : "Lieu",
          "repas" : "Repas",
          "trajet" : "Trajet",
          "trajetPreRempli" : "Trajet pré-rempli",
          "nuit" : "Nuit",
          "nuitMinuscule" : "nuit",
          "location" : "Location",
          "masquees" : "masquées",
          "informationCookies1" : "Pour afficher l'outil de réservation, vous devez accepter les cookies de type 'Publicité ciblée' (",
          "informationCookies2" : "voir l'explication",
          "informationCookies3" : "Pour autoriser les cookies de type 'Publicité ciblée' sur le site tripkygo",
          "informationCookies4" : ", veuillez :",
          "informationCookies5" : "1) cliquer sur l'icone ",
          "informationCookies6" : " en bas à droite de votre écran",
          "informationCookies7" : "2) accepter les cookies de type 'Publicité ciblée' ",
          "informationCookies8" : "3) cliquer sur 'Sauvegarder' en bas de la fenêtre",
          "informationCookies9" : "4) actualiser la page",
          "informationCookies10" : "Les outils de recherche seront désormais visibles !",
          "informationCookies11" : "En utilisant ces outils de recherche, vous contribuerez à maintenir notre site 100% gratuit !",
          "partage" : "Partage",
          "copierLien" : "Copier le lien",
          "partagerFacebook" : "Partager sur Facebook",
          "partagerX" : "Partager sur X (Twitter)",
          "partagerProfil" : "Partager le profil",
          "envoyerParMail" : "Envoyer par mail",
          "envoyerParSms" : "Envoyer par sms",
          "envoyerParWhatsApp" : "Envoyer par WhatsApp",
          "integrerBlog" : "Intégrer sur un site/blog",
          "itineraireVoyage" : "Itinéraire de voyage",
          "messageRs" : "Mon itinéraire de voyage créé via @tripkygo",
          "messageRs2" : "Mon itinéraire de voyage peut t'intéresser",
          "lienCopie" : "Lien copié",
          "enregistrementMaj" : "Enregistrement",
          "creation" : "Création",
          "enCours" : "en cours, veuillez patienter...",
          "aeroportGareVille"  : "Aéroport, gare, ville...",
          "compagnie"  : "Compagnie",
          "refNumVol"  : "Réf, n° de vol,...",
          "debut" : "Début",
          "fin" : "Fin",
          "prix" : "Prix",
          "paye?" : "Payé ?",
          "paye" : "Payé",
          "nomVilleLieu"  : "Nom de la ville ou du lieu",
          "activitesVisites" : "Activités, visites,...",
          "nomRestaurantLieu"  : "Nom du restaurant ou du lieu",
          "descriptionRepas"  : "Description,...",
          "nomHebergement"  : "Nom de l'hébergement",
          "nomVille"  : "Nom de la ville",
          "prixNuit" : "Prix par nuit",
          "reference"  : "Référence,...",
          "agenceBoutique" : "Agence, boutique,...",
          "surPlace" : "Sur place",
          "prelevement" : "Prélèvement",
          "acompte" : "Acompte",
          "priseEnCharge" : "Prise en charge",
          "locationPriseEnCharge" : "Location - prise en charge",
          "restitution" : "Restitution",
          "locationRestitution" : "Location - restitution",
          "rattacherPEC" : "Rattacher prise en charge",
          "cliquezCompleter" : "Cliquez pour compléter",
          "nuitsIncompletes" : "Nuit(s) incomplète(s)",
          "nuitTransport" : "Nuit en transport",
          "lieuxVisites" : "Lieux visités",
          "dateDebut" : "Date de début :",
          "nombreNuits" : "Nombre de nuits :",
          "villeSejourner" : "Ville où vous séjournerez",
          "villeNonRenseignee" : "Ville non renseignée",
          "paysNonRenseigneCliquez" : "Pays non renseigné. Cliquez sur la ville et sélectionnez-la dans les choix proposés pour une sélection automatique du pays ou sélectionnez le pays ci-dessous.",
          "paysNonRenseigne" : "Pays non renseigné",
          "situationApresEnregistrement" : "Situation après enregistrement :",
          "du" : "du",
          "au" : "au",
          "liberee" : "libérée",
          "questionAjout" : "Que souhaitez-vous ajouter ?",
          "questionAjoutCoCreateur" : "Qui souhaitez-vous ajouter en co-créateur ?",
          "cliquezPourEchanger" : "Cliquez pour échanger le contenu avec le jour suivant",
          "coordonneesGPSAbsentes" : "Coordonnées GPS absentes",
          "coordinateRetentionTitle" : "Localisation non identifiée",
          "coordinateRetentionMessage" : "Vous avez modifié {{field}} sans sélectionner un élément dans les suggestions. La nouvelle localisation n’a donc pas pu être identifiée.\n\nSouhaitez-vous conserver les coordonnées GPS précédemment enregistrées pour cet élément ?",
          "coordinateRetentionClear" : "Effacer",
          "coordinateRetentionKeep" : "Conserver",
          "coordinateFieldPlace" : "le nom du lieu",
          "coordinateFieldCity" : "le nom de la ville",
          "coordinateFieldAccommodation" : "le nom de l’hébergement",
          "coordinateFieldDeparture" : "le lieu de départ",
          "coordinateFieldArrival" : "le lieu d’arrivée",
          "cliquezCarte" : "Cliquez pour voir sur la carte",
          "cliquezPlacement" : "Cliquez pour placer sur la carte",
          "recherche" : "Recherche",
          "blocNotes" : "Bloc-notes",
          "confirmation" : "Confirmation",
          "coordonnees" : "Coordonnées",
          "lien" : "Lien",
          "suppression" : "Suppression",
          "pointsInteret" : "Points d'intérêt",
          "itineraire" : "Itinéraire",
          "informations" : "Informations",
          "copie" : "Copie",
          "afficherStatistiques" : "Afficher les statistiques",
          "convertisseurMonnaies" : "Convertisseur de monnaies",
          "exporterItineraire" : "Exporter l'itinéraire",
          "importerItineraire" : "Importer l'itinéraire",
          "editerPDF" : "Editer en PDF",
          "integrerItineraire" : "Intégrer l'itinéraire sur un blog/site",
          "faireMaValise" : "Faire ma valise",
          "partagerItineraire" : "Partager l'itinéraire",
          "chargementDiagramme" : "Chargement du diagramme...",
          "repartitionBudget" : "Répartition du budget",
          "activites" : "Activités",
          "hebergements" : "Hébergements",
          "autresFrais" : "Autres frais",
          "frais" : "Frais",
          "fraisPersonnalises" : "Frais personnalisés",
          "informationsFrais" : "Informations sur les frais",
          "ajoutezInformations" : "Ajoutez des informations",
          "nouveauTypeFrais" : "Nouveau type de frais...",
          "visas" : "Visa(s)",
          "vaccins" : "Vaccin(s)",
          "carburant" : "Carburant",
          "nourriture" : "Nourriture",
          "vehicule" : "Véhicule",
          "autres" : "Autres",
          "materiel" : "Matériel",
          "resteAPayer" : "Reste à payer",
          "dejaPaye" : "Déjà payé",
          "totalPour" : "Total pour",
          "parPersonne" : "par personne",
          "kmParcourus" : "km parcourus",
          "exportezItineraire" : "Exportez votre itinéraire pour le visualiser sur d'autres sites/applications (Google Maps, Maps.Me, OpenStreetMap,...).",
          "elementsExporter" : "Elements à exporter",
          "tousExporter" : "Tous (lieux, repas, trajets, locations et nuits)",
          "seulementExporter" :"Seulement les lieux et les repas",
          "exporter" : "Exporter",
          "importezItineraire" : "Importez des données cartographiques au format KML/KMZ (Google Maps, Maps.Me, OpenStreetMap,...)",
          "kmlKmzAcceptes" : ".kml et kmz acceptés",
          "lieuxImportes" : "Lieux importés :",
          "selectionnezJour" : "Sélectionnez un jour",
          "selectionnezPositionnement" : "Sélectionnez un positionnement",
          "lieuAjoute" : "Lieu ajouté",
          "integrationItineraire" : "Intégration de l'itinéraire sur votre site/blog",
          "quelleVue" : "Quelle vue souhaitez-vous afficher par défaut ?",
          "previsualisezItineraire" : "Prévisualisez l'itinéraire intégré",
          "codeAUtiliser" : "Code à utiliser :",
          "pourAjuster" : "Pour ajuster la hauteur de la fenêtre, lisez",
          "commentIntegrer" : "Comment intégrer un itinéraire tripkygo sur un site/blog ?",
          "notificationEmail" : "Notification email 48h avant le départ ?",
          "objet" : "Objet",
          "ajouter" : "Ajouter",
          "ajoutEnCours" : "Ajout en cours, veuillez patienter...",
          "echangeEnCours" : "Echange en cours, veuillez patienter...",
          "copieEnCours" : "Copie en cours, veuillez patienter...",
          "gestionCoCreateurs" : "Gestion des co-créateurs",
          "coCreateurs" : "Co-créateur(s) :",
          "envoiDemandeCoCreateurs" : "Envoi de la demande en cours, veuillez patienter...",

          "alertPaysSaisi" : "Vous avez déjà saisi ce pays, veuillez saisir le pays suivant ou passer à la saisie des autres critères !",
          "alertDestination" : "Vous devez sélectionner une destination !",
          "alertIADestinationInvalide": "L'IA n'a pas généré correctement le voyage. Merci de repréciser clairement la destination à l'assistant IA.",
          "alertDateDeb" :"Vous devez sélectionner une date de début de voyage !",
          "alertDateFin" :"Vous devez sélectionner une date de fin de voyage !",
          "alertNbVoyageurs" :"Vous devez ajouter au moins 1 voyageur !",
          "alertNbJoursMax" :"Votre voyage ne doit pas dépasser 365 jours ! Merci de créer plusieurs voyages.",
          "alertNbJoursMin" :"Votre voyage doit durer au moins deux jours.",
          "alertCopie" : "Vous devez être connecté(e) pour copier un voyage. \nVous n'avez pas de compte ? Inscrivez-vous, c'est gratuit !",
          "alertPartage" : "Vous devez être connecté(e) pour partager un voyage. \nVous n'avez pas de compte ? Inscrivez-vous, c'est gratuit !",
          "alertCreateurs" : "Vous devez être connecté(e) pour modifier les créateurs d'un voyage. \nVous n'avez pas de compte ? Inscrivez-vous, c'est gratuit !",
          "alertMajConnecte" : "Erreur lors de la mise à jour, vous n'êtes plus connecté(e).",
          "alertSaisieRapide" : "Ne seriez-vous pas un peu rapide ?",
          "alertNom" : "Vous devez saisir un nom !",
          "alertEmail" : "Vous devez saisir une adresse email valide !",
          "alertSujet" : "Vous devez saisir un sujet !",
          "alertMessage" : "Vous devez saisir un message d'au moins 30 caractères !",
          "alertRecaptcha" : 'Veuillez cocher la case "Je ne suis pas un robot".',
          "alertTechnique" : "Erreur technique !",
          "alertVerifReinit" : "Erreur lors de la verif reinit.",
          "alertMailIncorrect" : "Adresse mail ou code de réinitalisation incorrect",
          "alertDelaiReinit" : 'Délai de réinitialisation expiré, veuillez recommencer la procédure en cliquant sur "Mot de passe oublié".',
          "alertEnvoiMail" : "Erreur lors de l'evoi du message.",
          "alertPasCompte" : "Il n'existe pas de compte pour cette adresse email !",
          "alertMailRecup" : "Si un compte existe pour cette adresse, un e-mail de récupération de mot de passe a été envoyé.",
          "alertMailRecupSuite" : "\nVous avez 1h pour effectuer la procédure de réinitialisation sinon il faudra recommencer.\nSi vous ne le trouvez pas, pensez à vérifier votre dossier spams ou contactez-nous !",
          "alertMailRecupFin" : "\nVous avez 1h pour effectuer la procédure de réinitialisation sinon il faudra recommencer.\nSi vous ne le trouvez pas, pensez à vérifier votre dossier spams !\n\nSi votre messagerie est chez orange.fr et que vous ne recevez pas le mail, merci de nous contacter car leur serveur bloque nos envois de mails automatiques.",
          "alertMdpInvalide" : "Mot de passe invalide !\nVeuillez saisir plus de 5 caractères avec au moins un chiffre, une lettre minuscule et une majuscule.",
          "alertMdpDifferents" : "Les mots de passe saisis ne sont pas identiques !",
          "alertInscriptionImpossible" : "Inscription impossible, il existe déjà un compte pour cette adresse email !", 
          "alertDoubleMdp" : "Vous devez remplir les deux champs de mot de passe !",
          "alertMdpModifie" : "Mot de passe modifié !\nVous pouvez désormais vous connecter avec votre nouveau mot de passe.",
          "alertErreurReinit" : "Erreur lors de la réinitialisation du mot de passe .",
          "alertUsernameInvalide" : "Le nom d'utilisateur n'est pas valide. Il doit faire entre 5 et 20 caractères en commençant par une lettre. Seuls les lettres, chiffres, points, tirets et tirets bas sont acceptés !",
          "alertChampSiteInvalide" : "Le site n'est pas valide. Il ne peut pas y avoir d'espace dans l'adresse url d'un site internet. Veuillez le corriger sinon il ne sera pas enregistré !",
          "alertChampRSInvalide" : "Le nom d'utilisateur d'un réseau social ne doit donc contenir ni @ ni espace.\nVeuillez le corriger sinon il ne sera pas enregistré !\n\nExemple :\n- https://www.facebook.com/tripkygo/ : saisir tripkygo\n- https://www.instagram.com/tripkygo : saisir tripkygo\n- https://www.x.com/tripkygo : saisir tripkygo\n- https://www.youtube.com/@tripkygo saisir tripkygo",
          "alertRecupProfil" : "Erreur lors de la récupération du profil",
          "alertEnregProfil" : "Erreur lors de l'enegistrement du profil, vous n'êtes plus connecté(e).",
          "alertEnregPhoto" : "Erreur lors de l'enegistrement de la photo, vous n'êtes plus connecté(e).",
          "alertFormatFichier" : "Veuillez sélectionner un fichier JPEG, JPG, PNG, wEBP, HEIC ou HEIF.",
          "alertTailleFichier" : "La taille du fichier ne doit pas dépasser 12 Mo.",
          "alertEnregMdp" : "Erreur lors de l'enregistrement du nouveau mot de passe, vous n'êtes plus connecté(e).",
          "alertErreurSuppCompte" : "Erreur lors de la suppression du compte",
          "alertPlusConnecte" : ", vous n'êtes plus connecté(e)",
          "alertErreurNewsletter" : "Erreur lors de l'inscription à la newsletter",
          "alertNewsletterOK" : "Inscription à la newsletter réussie !",
          "emailVerificationTitle": "Vérification de l'adresse e-mail",
          "emailVerificationSent": "Un e-mail de confirmation a été envoyé à",
          "emailVerificationInstruction": "Veuillez l'ouvrir et cliquer sur le lien de confirmation pour activer votre compte.",
          "emailConfirmationTitle": "Confirmation de l'adresse e-mail",
          "emailConfirmationLoading": "Validation de votre adresse e-mail en cours, merci de patienter quelques secondes...",
          "emailConfirmationSuccess": "Adresse e-mail confirmée !",
          "emailAccountActivated": "Votre compte tripkygo est maintenant activé, il ne vous reste plus qu'à vous connecter.",
          "emailInvalidLinkTitle": "Lien invalide",
          "emailConfirmationImpossible": "Confirmation impossible",
          "emailBackToLogin": "Retour à la connexion",
          "emailLinkIncomplete": "Le lien de confirmation est incomplet.",
          "emailConfirmationFailed": "Impossible de confirmer votre adresse e-mail.",
          "emailLinkInvalid": "Ce lien de confirmation est invalide ou a déjà été utilisé.",
          "emailConfirmationError": "Une erreur est survenue lors de la confirmation de votre adresse e-mail.",
          "alertVoyagePublic" : "Ce voyage est public, voulez-vous le rendre privé ?\n\nIl ne sera plus visible sur notre page d'accueil.",
          "alertVoyagePrive" : "Ce voyage est en mode privé, souhaitez-vous le rendre public ?\n\nIl sera accessible par tous depuis notre page d'accueil, vous pourrez le partager et même l'intégrer sur votre blog ou site. Renseignez votre compte Instagram sur votre profil tripkygo et nous vous mentionnerons en story Instagram pour présenter votre itinéraire.\n\nVous pouvez masquer certaines informations en réglant les paramètres de confidentialité de vos voyages publics dans votre compte.",
          "alertAccepterCoCreateur" : "Vous êtes désormais co-créateur de cet itinéraire. Après actualisation de la page, il va apparaître dans la liste de vos voyages",
          "alertRefuserCoCreateur" : "Confirmez-vous votre refus pour devenir co-créateur du voyage ?",
          "alertSupprimerCoCreateur": "Confirmez-vous le retrait des droits de co-createur à ",

          "confirmRepousser" : "Etes-vous sûr de vouloir repousser le début de votre voyage et avancer la date de fin ? Vous perdrez les données enregistrées pour les dates supprimées.",
          "confirmDecaler" : "Vous décalez les dates de votre voyage en conservant le même nombre de jours, vous conserverez donc toutes les données précédemment enregistrées qui seront décalées.",
          "confirmDiminuer" : "Etes-vous sûr de vouloir diminuer la durée de votre voyage ? Vous perdrez les données enregistrées pour les jours supprimés.",
          "confirmSuppressionCompte" : "Êtes-vous sûr de vouloir définitivement supprimer votre compte et vos voyages ?",
          
          "lienPlanificateur" : "/planificateur-voyage",
          "lienMesVoyages": "/mes-voyages",
          "lienVoyagesPartages": "/voyages-partages",
          "lienStatistiques": "/mes-statistiques",
          "lienVoyageur": "/voyageur",
          "lienAide" : "/aide",
          "lienGuides" : "/guides-pays",
          "lienGuide" : "/guide-pays",
          "lienContact" : "/contact",
          "lienHome" : "/",
          "lienAPropos" : "/a-propos",
          "lienNewsletter" : "/a-propos#newsletter",
          "lienMentionsLegales" : "/mentions-legales",
          "lienVoyagesPublics" : "/voyages/publics",
          "lienOuPartir" : "/ou-partir",
          "lienReservation" : "/reservation",
          "lienReservationTransport" : "/reservation-transport",
          "lienReservationAvion" : "/reservation-vol",
          "lienReservationHebergement" : "/reservation-hebergement",
          "lienReservationActivite" : "/reservation-activite",
          "lienReservationAssurance" : "/souscription-assurance",
          "lienLocationVoiture" : "/location-voiture",
          "lienCompte": "/account",
          "et": "et",
          "lienLogin": "/login",
          "lienSignUp": "/signup",
          "lienCompteConfidentialite": "/compte-confidentialite",
          "lienGestionCompte": "/gestion-compte",
          "lienCompteMdp" : "/account-password",
          "lienItineraireIntegre" : "/itineraire-voyage-integre",

          "trouvezInspiration" : "Trouvez l'inspiration",
          "decouvrezIncontournables" : "Découvrez les incontournables",
          "activitesTransportsHebergements" : "Activités, transports, hébergements,...",
          "trierVoyages" : "Trier les voyages",
          "filtrerPays" : "Filtrer par pays",
          "filtrerUtilisateur" : "Filtrer par utilisateur",
          "filtreRecherche" : "Rechercher un voyage, un pays, un utilisateur,...",
          "reinitialiser" : "Réinitialiser",
          "aucunVoyageTrouve" : "Aucun voyage trouvé pour ces critères",
          "essayerModifier" : "Essayez de modifier vos filtres ou de réinitialiser la recherche",    
          "veuillezPatienter" : "Veuillez patienter...",
          "envoyerIA" : "✨ Envoyer à l'IA",
          "analyseDemande" : "✨ Analyse de votre demande...",
          "resultatApproche" :  "⏳ Résultat en approche...",
          "generationVoyage" : "🗺 Génération de votre voyage...",
          "informationsManquantes" : "✨ Informations manquantes",
          "creerVoyageAssistant" : "Créer votre voyage avec notre assistant IA",
          "aiTripBetaNotice": "L’assistant IA est en version bêta : il peut encore se tromper ou proposer un itinéraire à ajuster. Vous pouvez lui demander de modifier le résultat avant de créer votre voyage.",
          "aiTripPreparing": "L’assistant prépare votre voyage sur mesure.",
          "aiTripGenerated": "✨ Voyage généré",
          "destination": "Destination",
          "destinations": "Destinations",
          "dates": "Dates",
          "decrivezVoyage" : "Décrivez simplement votre voyage.",
          "exemple1" : "Exemples :",
          "exemple2" : "- 2 semaines au Japon à partir du 24 avril 2028",
          "exemple3" : "- Je veux aller en Amérique du sud du 03/06/2027 au 03/07/2027",
          "exemple4" : "- Trouve moi une destination en Italie pour 1 semaine près de la mer en octobre 2026",
          "completezDemande" : "Complétez ou affinez le résultat en envoyant d'autres messages à l'IA",
          "limiteIA1" : "⏳ Vous avez atteint la limite de requêtes pour un utilisateur non connecté. Veuillez vous connecter à un compte pour continuer.",
          "limiteIA2" : "⏳ Vous avez atteint la limite de 20 requêtes par heure. Veuillez réessayer plus tard.",
          "erreurSurvenue" : "Une erreur est survenue",
          "duree" : "Durée",
          "creerLeVoyage" : "Créer le voyage",
          "effacerSuggestion" : "Effacer la suggestion",
          "suggestionItineraire" : "Suggestion d'itinéraire",
          "mardi" : "Mardi",
          "gareHakone" : "Gare de Hakone-Yumoto",
          "gareKyoto" : "Gare de Kyoto",
          "japon" : "Japon",
          "modalPlannerAI": {
  "title": "Assistant IA",
  "subtitle": "Je peux compléter, vérifier ou améliorer ton itinéraire.",
  "concernedDay": "Jour concerné",
  "allDays": "Tous les jours / pas de jour précis",
  "quickActions": "Actions rapides",
  "customRequest": "Demande personnalisée, question ou complément d'information",
  "placeholder": "Exemple : ajoute des activités culturelles à Kyoto sans trop marcher",
"placeholderAfterActivities": "Exemple : Je veux au moins 3 activités par jour",
"placeholderAfterTransports": "Exemple : Je préférerais faire le trajet entre Medellín et Bogotá en avion",
"placeholderAfterNights": "Exemple : Je veux passer plus de nuits à Bangkok",
"placeholderAfterCheck": "Exemple : Peux-tu me proposer une autre amélioration ?",
"placeholderAfterQuestion": "Exemple : Je souhaite préciser ma demande...",
  "forgetConversation": "Oublier la conversation",
  "sendToAI": "Envoyer à l'IA",
  "analysisInProgress": "Analyse en cours...",
  "assistantAnalyzing": "L’assistant analyse ton itinéraire...",
  "assistantResponse": "Réponse de l’assistant",
  "summary": "Résumé",
  "warnings": "Points d’attention",
  "suggestedActions": "Actions proposées",
  "informations": "Informations",
  "remove": "Retirer",
  "close": "Fermer",
  "applyProposal": "Valider la proposition",
  "betaLabel": "Information sur la version bêta de l'assistant IA",
  "betaNotice": "L’assistant IA est en version bêta : il peut encore se tromper ou donner des réponses à ajuster. Vous pouvez lui demander de modifier le résultat avant de valider une proposition.",
  "processing": "Traitement en cours, veuillez patienter...",
  "processingShort": "Traitement en cours...",
  "applyError": "Erreur lors de l’application de la proposition.",

  "chooseActionError": "Choisis une action ou écris une demande avant d’envoyer à l’IA.",
  "loginRequired": "Tu dois être connecté(e) à un compte pour continuer à utiliser l’assistant IA.",
  "limitReached": "La limite de requêtes IA est atteinte. Réessaie un peu plus tard.",
  "incompleteRequest": "La demande envoyée à l’assistant est incomplète.",
  "assistantError": "Erreur lors de l’appel à l’assistant IA.",
  "assistantDefaultResponse": "L’assistant a répondu.",

  "addActivities": "Ajouter des activités/visites",
  "fixTransports": "Ajouter/corriger des trajets",
  "rebalanceNights": "Rééquilibrer les nuits",
  "checkItinerary": "Vérifier la cohérence",
  "askQuestion": "Poser une question",

  "meal": "Repas",
  "place": "Lieu",
  "transport": "Trajet",
  "transportToFix": "Trajet à corriger",
  "rebalance": "Rééquilibrage",
  "suggestion": "Suggestion",
  "information": "Information",
  "proposal": "Proposition",

  "groupSinglePlaces": "Vous pouvez demander à l'IA de regrouper ces éléments par ville pour créer moins d'éléments \"Lieu\"",
  "groupedDayInfo": "Activités regroupées dans un seul élément \"Lieu\" mais vous pouvez demander à l'IA de créer un \"Lieu\" par activité/visite",
  "transportMean": "Moyen de transport :",
  "itineraryProposal": "Proposition d’itinéraire",
  "nightsOnlyModified": "Si vous validez la modification, seuls les éléments nuits seront modifiés.",
  "stage": "Étape",
  "days": "Jours",
  "to": "à",
  "night": "nuit",
  "nights": "nuits",

  "plane": "Avion",
  "train": "Train/métro",
  "car": "Voiture",
  "bus": "Bus",
  "taxi": "Taxi",
  "ship": "Bateau",
  "walking": "À pied",
  "bicycle": "Vélo",
  "motorcycle": "Moto/Scooter"
},
"lieuxMinuscule": "lieux",
"groupe": "Groupe",
"legende": "Légende",
"masquerLegende": "Cliquer pour masquer la légende",
"libelles": "Libellés",
"mapPlacementAlert": "Pour ajouter des coordonnées par clic droit sur la carte (ou appui long pour les écrans tactiles), veuillez d'abord sélectionner le lieu sans coordonnée GPS à placer en cliquant sur l'icône rose à côté de son libellé.",
"calculItineraireEnCours": "Calcul d'itinéraire en cours, veuillez patienter...",
"photoBulk": {
  "addPhotos": "Ajouter des photos",
  "selectPhotos": "Ajoutez des photos",
  "dropTitle": "Glissez-déposez vos photos ici",
  "dropNow": "Déposez vos photos ici",
  "dropHint": "ou sélectionnez-les depuis votre appareil",
  "browse": "ou cliquez",
  "formats": "JPEG, PNG, WEBP, HEIC ou HEIF · 12 Mo maximum par photo",
  "title": "Associez les photos aux étapes",
  "intro": "Une étape ne peut être associée à une photo que si elle possède un libellé.",
  "introSuite": "Nous utilisons la date et les coordonnées GPS de la photo lorsqu'elles sont disponibles pour proposer une étape. Vous pouvez modifier ou retirer chaque association avant l'enregistrement.",
  "information": "Informations",
  "batchLimit": "Seules les {{count}} premières photos de cette sélection sont affichées.",
  "invalidFormat": "Format de fichier non pris en charge (JPEG, PNG, WEBP, HEIC ou HEIF uniquement).",
  "tooLarge": "Cette photo dépasse la limite de 12 Mo.",
  "readingMetadata": "Lecture des informations de la photo...",
  "preparing": "Traitement des photos en cours...",
  "preparingHint": "Création des miniatures, lecture des métadonnées et tri des photos.",
  "noDate": "Date indisponible",
  "noGps": "GPS indisponible",
  "association": "Étape associée",
  "notAssociated": "Ne pas enregistrer cette photo",
  "replacesExisting": "remplacera la photo actuelle",
  "replaceWarning": "Cette étape possède déjà une photo. Elle sera remplacée après validation.",
  "remove": "Retirer",
  "selectedCount": "{{count}} photo(s) associée(s)",
  "progress": "Enregistrement de la photo {{current}} sur {{total}}...",
  "uploading": "Enregistrement...",
  "validate": "Enregistrer les photos associées",
  "uploadError": "Une erreur est survenue pendant l'enregistrement. Les photos déjà traitées peuvent avoir été enregistrées.",
  "loading": "Récupération des photos en cours, veuillez patienter...",
  "noneInPlanner": "Aucune photo n'a été ajoutée",
  "none": "Aucune photo",
  "showAll": "Afficher tout",
  "deleteConfirmation": "Supprimer définitivement la photo associée à {{label}} ?",
  "deleteError": "La photo n'a pas pu être supprimée. Veuillez réessayer.",
  "annuler": "Annuler"
},
"planner": {
  "loading": "Chargement en cours...",
  "fileProcessing": "Traitement du fichier en cours...",
  "betweenAdjacentItems": "À partir des éléments précédent et suivant",
  "mapNeedsLocation": "Pour visualiser la carte, vous devez d'abord saisir au moins un lieu géolocalisé sur le planning.",
  "mapNoLocation": "Il n'y a pas de lieu géolocalisé sur le planning pour afficher la carte.",
  "notesPlaceholder": "Notez vos idées ou informations complémentaires pour cette étape...",
  "notesPrivacy": "Les informations saisies dans les blocs-notes ne sont visibles que par le créateur du voyage et lors d'un partage de voyage si l'option a été sélectionnée.",
  "linkEdit": "Ajout/modification d'un lien",
  "linkPlaceholder": "Saisir le lien",
  "status": "État :",
  "reason": "Motif :",
  "publicLink": "Lien pour les autres utilisateurs (voyages publics ou partagés) :",
  "linkReview": "Pour les voyages publics ou partagés, les liens ne seront visibles par les autres utilisateurs qu'après validation par nos services (sous 48 h maximum).",
  "affiliateWarning": "Les identifiants d'affiliation présents dans les liens pourront être supprimés ou remplacés par nos services durant la phase de validation.",
  "linkPrivacy": "Affichez ou masquez les liens de vos voyages publics dans les paramètres de confidentialité de votre compte.",
  "linkRejected": "lien refusé",
  "linkApproved": "lien validé",
  "linkModified": "lien validé après modification par nos services",
  "linkPending": "validation en cours",
  "gpsEdit": "Ajout/modification des coordonnées GPS",
  "gpsMapHint": "Les coordonnées peuvent également être ajoutées et modifiées depuis la carte.",
  "bookingDocumentEdit": "Ajout/modification d'une confirmation de réservation",
  "bookingDocument": "Confirmation de réservation",
  "acceptedFiles": "JPEG, JPG, PNG, WEBP, HEIC et HEIF acceptés, 12 Mo maximum",
  "documentRetentionBefore": "Les documents seront supprimés",
  "documentRetentionDuration": "3 mois",
  "documentRetentionAfter": "après la date de fin du voyage.",
  "documentRetentionAdvice": "Si vous souhaitez les conserver, pensez à générer une édition PDF de l'itinéraire depuis Mes voyages.",
  "pastTripDocument": "Vous ne pouvez pas ajouter de confirmation de réservation à un voyage dont la date de fin est passée.",
  "page": "Page",
  "of": "sur",
  "shareTitle": "Partage individuel",
  "shareRecipient": "Avec qui souhaitez-vous partager votre voyage ?",
  "shareOptions": "Souhaitez-vous partager les informations suivantes ?",
  "budgetView": "Vue Budget",
  "confirmations": "Confirmations",
  "links": "Liens",
  "share": "Partager",
  "shareNotice": "La personne avec qui vous partagez votre voyage ne pourra faire aucune modification.",
  "sharePdfNotice": "Elle pourra éditer la feuille de route en PDF, mais pas le carnet de voyage.",
  "sharing": "Partage en cours, veuillez patienter...",
  "pdfTitle": "Édition PDF",
  "pdfTypeQuestion": "Quel type de document souhaitez-vous créer ?",
  "roadmap": "Feuille de route",
  "photoBook": "Carnet de voyage avec photos",
  "includeQuestion": "Souhaitez-vous inclure les informations suivantes ?",
  "gpsCoordinates": "Coordonnées GPS",
  "generate": "Générer",
  "pdfGenerating": "Édition en cours, veuillez patienter...",
  "coCreatorNotice": "Les co-créateurs ont accès à toutes les informations du voyage. Ils peuvent le modifier et le partager, mais ils ne peuvent pas le supprimer ni ajouter d'autres co-créateurs.",
  "readOnlyShareBefore": "Si vous souhaitez donner un accès uniquement en consultation, utilisez plutôt la",
  "readOnlyShareLink": "fonctionnalité de partage",
  "totalNightsQuestion": "Indiquez le nombre total de nuits que vous passerez dans cet hébergement :",
  "numberOfNights": "Nombre de nuits",
  "copy": "Copier",
  "nearbyPoi": "Points d'intérêt à proximité de l'étape",
  "noNearbyPoi": "Aucun point d'intérêt trouvé à proximité",
  "providedBy": "Fourni par",
  "addToActivities": "Ajouter aux activités de l'étape",
  "createNewStop": "Créer une nouvelle étape",
  "addedToActivities": "Ajouté aux activités de l'étape !",
  "placeCreated": "Lieu créé !",
  "coCreatorRequestBefore": "Acceptez-vous la demande de",
  "coCreatorRequestAfter": "pour devenir co-créateur de son voyage n°",
  "newLabel": "NOUVEAU",
  "v3Announcement": "Vous pouvez désormais ajouter plusieurs photos en une seule fois et les associer facilement aux étapes de votre voyage. Rendez-vous dans l'onglet « Photos » du planificateur 📸",
  "surveyTitle": "VOTRE AVIS EST IMPORTANT (seulement 2 questions) :",
  "surveySubscription": "Dans le cadre du développement de tripkygo 🚀, seriez-vous intéressé(e) par la souscription d'un abonnement à faible coût afin de bénéficier de fonctionnalités premium ?",
  "examples": "Exemples :",
  "premiumMobile": "accès à une application mobile pour consulter ses voyages hors ligne",
  "premiumPhotos": "ajout de plusieurs photos par étape",
  "premiumGroupCosts": "calculateur des dépenses de groupe pour répartir les coûts entre les participants",
  "premiumCurrencies": "gestion de plusieurs monnaies pour un même voyage",
  "premiumRoadRoute": "tracé d'un itinéraire routier sur la carte",
  "premiumBookLayout": "personnalisation de la mise en page du carnet de voyage",
  "yes": "Oui 👍",
  "no": "Non 👎",
  "surveyPrice": "Quelle somme mensuelle seriez-vous prêt(e) à débourser au maximum pour cet abonnement premium ?",
  "surveyPriceHint": "Abonnement plus élevé = plus de fonctionnalités",
  "perMonth": "/mois",
  "moreThan": "plus de",
  "sendAnswer": "Envoyer ma réponse",
  "refuseError": "Erreur lors du refus.",
  "usernameRequiredToRefuse": "Vous devez saisir un nom d'utilisateur dans Mon compte pour refuser de devenir co-créateur d'un voyage."
}
        }
      }
    },
    lng: 'fr', // langue par défaut
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
